import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import AnimatedBackground from "../AnimatedBackground/AnimatedBackground"

const RootLayout = ({ element }) => {
  const data = useStaticQuery(graphql`
    query rootLayoutBgQuery {
      fullBg: file(relativePath: { eq: "fullBg.jpg" }) {
        childImageSharp {
          gatsbyImageData(layout: FULL_WIDTH)
        }
      }
    }
  `)
  const fullBgImage = data.fullBg.childImageSharp.gatsbyImageData

  return (
    <>
      <AnimatedBackground fullBg={fullBgImage} />
      {element}
    </>
  )
}

export default RootLayout
